import { LitElement } from 'lit';
import '../../js/locales/moment';
import $ from 'jquery';
import parsley from 'parsleyjs';
import {gaReady} from '../../js/utils/gaready';

class FitContactForm extends LitElement {
  static get is() { return 'fit-contact-form'; }

  // No shadow dom necessary
  createRenderRoot() { return this; }

  connectedCallback() {
    this.initializeParsley();

    $("fieldset[class^='reason--']").hide();
    gaReady().then((() => {
      const clientId = ga.getAll()[0].get('clientId');
      $('#gaclid').val(clientId);
    }));

    $('input[name=Reason]').change(() => {
      $("fieldset[class^='reason--']").hide();
      const item = $('input[name=Reason]:checked').val();
      switch (item) {
        case 'TravelRequests':
          $('.reason--travel').show();
          break;
        case 'HotelQuestion':
          $('.reason--hotel').show();
          break;
        case 'BookingQuestion':
          $('.reason--booking').show();
          break;
        case 'Feedback':
          $('.reason--feedback').show();
          break;
        case 'Other':
          $('.reason--other').show();
          break;
      }
    });
  }

  initializeParsley() {
    const form = this.querySelector('[data-parsley-validate]');
    $(form).parsley(window.ParsleyConfig);
  }
}

customElements.define(FitContactForm.is, FitContactForm);
